"use client";

import { Hammer } from "lucide-react";

import { Button } from "@/components/ui/button";

interface DeveloperButtonProps {
  variant?: "default" | "mute";
  onClick?: () => void;
  disabled?: boolean;
  title?: string;
  "aria-label"?: string;
  children?: React.ReactNode;
}

/**
 * A button component styled for developer-only features.
 * Displays a small hammer badge in the top-right corner.
 */
export function DeveloperButton({
  variant = "default",
  onClick,
  disabled = false,
  title,
  "aria-label": ariaLabel,
  children,
}: DeveloperButtonProps) {
  return (
    <Button
      variant={variant === "default" ? "default" : "mute"}
      size="auto"
      onClick={onClick}
      disabled={disabled}
      title={title}
      aria-label={ariaLabel}
      className={`relative ${
        variant === "default"
          ? "bg-color-developer-bg text-white dark:text-color-developer-text hover:bg-color-developer-bg/80"
          : ""
      }`}
    >
      {children}

      {/* Developer badge - purple with hammer icon */}
      <span className="absolute -top-0.5 -right-0.5 flex size-3.5 items-center justify-center rounded-full bg-purple-700 dark:bg-purple-600 transition-all duration-300 ease-out">
        <Hammer className="size-2.5 text-white" strokeWidth={2} />
      </span>
    </Button>
  );
}
